import React from 'react';
import { Card, Center } from '@mantine/core';
import { Navigate, useLoaderData, useParams } from 'react-router-dom';
import { SubmittableTechnology } from '../../../backend/models/technology';
import TechnologyForm from './Form';
import { updateTechnology } from '../../Util/server';
import { AggregatedDataLoaderResult } from '../../Loaders/AggregatedDataLoader';

const UpdateTechnology = () => {
  const { technologies, rings, sections, tags, clients, persons } = useLoaderData() as AggregatedDataLoaderResult;
  const { name } = useParams();

  const technology = technologies.find((t) => t.name === name);

  if (technology === undefined || technology?.id === undefined) {
    return <Navigate to={'/'} replace />;
  }

  return (
    <Center>
      <Card withBorder shadow="sm">
        <TechnologyForm
          data={technology}
          rings={rings}
          sections={sections}
          clients={clients}
          tags={tags}
          persons={persons}
          names={technologies.map((t) => t.name)}
          buttonLabel="Save"
          onSubmit={(values: SubmittableTechnology) => updateTechnology(values, technology.id)}
          add={false}
          successMessage="Technology updated successfully"
        />
      </Card>
    </Center>
  );
};

export default UpdateTechnology;
